import React from "react";
import AboutComponent1 from "../../components/AboutComponents/AboutComponent1/AboutComponent1";
import ModelsComponent2 from "../../components/ModelsComponent/modelsComponent2";
import HomeComponent12 from "../../components/HomeComponents/HomeComponent12/HomeComponent12";
import { ImageUrl } from "../../config/helper";

const About = () => {
  return (
    <div>
      <AboutComponent1
        image={ImageUrl("slice1.jpg")}
        heading="Our Models"
      />
      <HomeComponent12 />
      <ModelsComponent2 />
     
    </div>
  );
};

export default About;
